import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Credential Requests|Rebuild Request Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryRebuildRequestModal';
export type SPCandidateHistoryRebuildRequestModalLocNames =
	| `${LocNameStart}TitleModal`
	| `${LocNameStart}ContentInstructions`
	| `${LocNameStart}LabelEffectiveDate`
	| `${LocNameStart}ErrorEffectiveDateRequired`
	| `${LocNameStart}LabelComments`
	| `${LocNameStart}ErrorCommentsRequired`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonContinue`;

export const spCandidateHistoryRebuildRequestModalLocs: LocDefs<SPCandidateHistoryRebuildRequestModalLocNames> =
	{
		SPCandidateHistoryRebuildRequestModalTitleModal: {
			defaultValue: 'Rebuild Request',
			description: 'Modal Title',
			displayPath: `${pathStart}Modal Title`,
			displayType: 'Title',
			legacyName: 'Credential/RebuildRequestModal.Title.RebuildRequest',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRebuildRequestModalContentInstructions: {
			defaultValue:
				"Rebuilding credential data will cause credential data on or after the specified date to be removed from the system. The system will then begin with that date and rebuild the candidate's credential history up until the present; manual changes will be preserved.",
			description: 'Instructions content',
			displayPath: `${pathStart}Instructions`,
			displayType: 'Content',
			legacyName: 'Credential/RebuildRequestModal.Content.Instructions',
			htmlAllowed: true,
			...sharedProperties,
		},
		SPCandidateHistoryRebuildRequestModalLabelEffectiveDate: {
			defaultValue: 'Effective Date',
			description: 'Label for effective date field',
			displayPath: `${pathStart}Effective Date`,
			displayType: 'Label',
			legacyName: 'Credential/RebuildRequestModal.FieldLabel.EffectiveDate',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRebuildRequestModalErrorEffectiveDateRequired: {
			defaultValue: 'This field is required',
			description: 'Error message for required effective date field',
			displayPath: `${pathStart}Effective Date Required`,
			displayType: 'Error',
			legacyName: 'Credential/RebuildRequestModal.FieldError.EffectiveDateRequired',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRebuildRequestModalLabelComments: {
			defaultValue: 'Comments',
			description: 'Label for comments field',
			displayPath: `${pathStart}Comments`,
			displayType: 'Label',
			legacyName: 'Credential/RebuildRequestModal.FieldLabel.Comments',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRebuildRequestModalErrorCommentsRequired: {
			defaultValue: 'This field is required',
			description: 'Error message for required comments field',
			displayPath: `${pathStart}Comments Required`,
			displayType: 'Error',
			legacyName: 'Credential/RebuildRequestModal.FieldError.CommentsRequired',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRebuildRequestModalButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button text',
			displayPath: `${pathStart}Cancel`,
			displayType: 'Button',
			legacyName: 'Credential/RebuildRequest.Modal.Button.Cancel',
			htmlAllowed: false,
			...sharedProperties,
		},
		SPCandidateHistoryRebuildRequestModalButtonContinue: {
			defaultValue: 'Continue',
			description: 'Continue button text',
			displayPath: `${pathStart}Continue`,
			displayType: 'Button',
			legacyName: 'Credential/RebuildRequest.Modal.Button.Continue',
			htmlAllowed: false,
			...sharedProperties,
		},
	};

export type SPCandidateHistoryRebuildRequestModalLocType =
	LocMap<SPCandidateHistoryRebuildRequestModalLocNames>;
